export enum StatusTamanho {
    PADRAO = 'max-w-13 min-w-13',
    REDUZIDO = 'max-w-8 min-w-8',
}
